// extracted by mini-css-extract-plugin
export default {"OpenMapAppModal":"Styles_OpenMapAppModal__vO0L2","Title":"Styles_Title__p-lzb","CloseIcon":"Styles_CloseIcon__EMOc9"};